import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import AdminGroup from "../../common/AdminGroup";
import GroupSearchModal from "../../common/GroupSearchModal";
import { Divider } from "antd";
import { EditOutlined } from "@ant-design/icons";

const AssignAdministratorGroup = React.forwardRef(
  ({ value = undefined, onChange, disabled }, ref) => {
    const [groupId, setGroupId] = useState(value || undefined);

    const selectNewGroup = (group) => {
      if (group && group.id) {
        setGroupId(group.id);
        triggerChange(group.id);
      }
    };

    const triggerChange = (changedValue) => {
      if (onChange) {
        onChange(changedValue);
      }
    };

    const clear = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setGroupId(undefined);
      triggerChange(undefined);
    };

    return (
      <span ref={ref}>
        {!groupId && <span>None </span>}
        {groupId && <AdminGroup adminId={groupId} />}
        {!disabled && (
          <>
            <Divider type="vertical" />
            <GroupSearchModal
              title="Assign Admin Group"
              onSelect={selectNewGroup}
              icon={<EditOutlined />}
            />
          </>
        )}

        {!disabled && groupId && (
          <>
            <Divider type="vertical" />
            <Button
              id="deleteButton"
              color="red"
              icon={<DeleteOutlined />}
              onClick={clear}
              size="small"
              variant="solid"
            />
          </>
        )}
      </span>
    );
  }
);

AssignAdministratorGroup.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default AssignAdministratorGroup;
